import { Component, h, State, Prop, Event, EventEmitter } from "@stencil/core";

@Component({
  tag: "biel-search-filters",
  styleUrl: "biel-search-filters.css",
  shadow: true
})
export class BielSearchFilters {
  @Prop() filters: { position: number, title: string, url: string }[];
  @Prop() disableFilters: boolean = false;

  @State() selectedFilter: number = 0;
  @Event() filterSelected: EventEmitter<string>;

  handleFilterClick(position: number, url: string) {
    if (this.selectedFilter !== position) {
      this.selectedFilter = position;
      this.filterSelected.emit(url);
    }
  }

  render() {
    return (
      <div class="biel-search-filters">
        <button key={0} class={`filter-button ${this.selectedFilter === 0 ? 'selected' : ''}`} onClick={() => this.handleFilterClick(0, "")}>All</button>
        {this.filters.map(filter => (
          <button key={filter.position} class={`filter-button ${this.selectedFilter === filter.position ? 'selected' : ''}`} onClick={() => this.handleFilterClick(filter.position, filter.url)}>{filter.title}</button>
        ))}
      </div>
    );
  }
}
